import FeatureGate from '@atlaskit/feature-gate-js-client';

function isAnalyticsEventsMigrated() {
	return FeatureGate.checkGate('ptc-enable-people-teams-ui-analytics-refactor');
}

export { isAnalyticsEventsMigrated };
